import classNames from 'classnames';
import React, { ReactNode } from 'react';

export interface HorizontalPillsItem {
    text: ReactNode;
    value: string;
    isNew?: boolean;
}

export interface HorizontalPillsStyle {
    container: string;
    itemSelected: string;
    itemInactive?: string;
    item: string;
    text: string;
    newText: string;
}

export type HorizontalPillsProps = {
    items: HorizontalPillsItem[];
    value: string;
    onChange: (value: string) => void;
    style: HorizontalPillsStyle;
};

export const HorizontalPills = ({ items, value, onChange, style }: HorizontalPillsProps) => {
    return (
        <ul className={style.container}>
            {items.map((item) => (
                <li
                    key={item.value}
                    className={classNames(
                        style.item,
                        value === item.value ? style.itemSelected : style.itemInactive
                    )}
                >
                    <button
                        onClick={(e) => {
                            onChange(item.value);
                            e.preventDefault();
                        }}
                        className="rounded-full"
                    >
                        <span className={style.text}>{item.text}</span>

                        {item.isNew && <span className={style.newText}>{'New!'}</span>}
                    </button>
                </li>
            ))}
        </ul>
    );
};
